const t = "styles-module__questionWrapper___GLtLu", e = "styles-module__multiPartQuestion___2BxGT", s = "styles-module__childQuestionWrapper___-7QN8", o = {
  questionWrapper: t,
  multiPartQuestion: e,
  childQuestionWrapper: s
};
export {
  s as childQuestionWrapper,
  o as default,
  e as multiPartQuestion,
  t as questionWrapper
};
